<script lang="ts">
  import { Form, FormGroup, Input, Label } from "sveltestrap";
  import { Supportedelements, SupportedelementsMessage, Textarea } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
</script>
<Card headerTitle={Supportedelements} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html SupportedelementsMessage}</span>
    </div>
    <div slot="contentbody">
      <Form class="was-validated">
        <FormGroup>
          <Label for="validationTextarea">{Textarea}</Label>
          <textarea
            class="form-control is-invalid"
            id="validationTextarea"
            placeholder="Required example textarea"
            required
          />
          <div class="invalid-feedback">
            {'Please enter a message in the textarea.'}
          </div>
        </FormGroup>
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            id="validationFormCheck1"
            type="checkbox"
            required
          />
          <Label class="form-check-label" for="validationFormCheck1"
            >{'Check this checkbox'}</Label
          >
          <div class="invalid-feedback">{'Example invalid feedback text'}</div>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            id="validationFormCheck2"
            type="radio"
            name="radio-stacked"
            required
          />
          <Label class="form-check-label" for="validationFormCheck2"
            >{'Toggle this radio'}</Label
          >
        </div>
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            id="validationFormCheck3"
            type="radio"
            name="radio-stacked"
            required
          />
          <Label class="form-check-label" for="validationFormCheck3"
            >{'Or toggle this other radio'}</Label
          >
          <div class="invalid-feedback">
            {'More example invalid feedback text'}
          </div>
        </div>
        <div class="mb-3">
            <select class="form-select" required aria-label="select example">
                <option value="">{'Open this select menu'}</option>
                <option value="1">{'One'}</option>
                <option value="2">{'Two'}</option>
                <option value="3">{'Three'}</option>
            </select>
          <div class="invalid-feedback">
            {'Example invalid select feedback'}
          </div>
        </div>
        <div>
          <Input
            type="file"
            aria-label="file example"
            required
          />
          <div class="invalid-feedback">
            {'Example invalid form file feedback'}
          </div>
        </div>
      </Form>
    </div>
</Card>